import m from "../../../../geodata/es2015/region/usa/tnHigh";
window.am4geodata_region_usa_tnHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/tnHigh.js
// module id = null
// module chunks = 